import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemSecondaryAction,
	ListItemText,
	Snackbar,
	makeStyles,
} from '@material-ui/core';
import AppContext from 'containers/App/Store/AppContext';
import {
	CommonStatus,
	OrderItemStatus,
	OrderStatus,
	useGetKitchenPrinterLazyQuery,
	useGetOrderLazyQuery,
	useGetOrderQuery,
	useGetOrderSummaryQuery,
	useGetOutletCustomerPolicyQuery,
	useGetOutletQuery,
	// useGetPrintDataSubscription,
	useGetPrinterOrderItemLazyQuery,
	useGetPrinterOrderItemQuery,
	useGetReceiptPrinterLazyQuery,
	useGetTableQuery,
	useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation, useParams } from 'react-router';
import { WSclient } from 'POSClient';
import {
	printReceipt,
	printReceiptText,
} from 'containers/OutletModule/Home/TableSubmenu/BillSettlement/BillReceipt/BillReceiptFunctions';
import { printOrderReceiptRawViaLocalAgent } from 'services/localPrintAgentReceipt';
import CloseIcon from '@material-ui/icons/Close';
import { useApolloClient } from '@apollo/client';
import { SocketContext } from 'containers/Socket/SocketContext';

const useStyles = makeStyles({
	spaced: {
		['& > *']: {
			marginRight: '0.5rem',
		},
		['& :not(span)']: {
			width: '0.8rem',
			height: '0.8rem',
		},
	},
});

export const PrinterWrapper = (props: any) => {
	const { socket }: any = useContext(SocketContext);
	const { outletID } = useParams<Record<string, any>>();
	const classes = useStyles();
	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const printOutletID = localStorage.getItem('latestOutlet');
	const login = localStorage.getItem('login');

	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState('');
	const [snackbarClosed, setsnackbarClosed] = useState(false);
	const [printOnce, setPrintOnce] = useState(false);

	const { globalState, dispatch }: any = useContext(AppContext as any);

	const history = useHistory();
	const location = useLocation();
	const client = useApolloClient();

	// Drawer Toggler
	const handleDrawer = () => {
		localStorage.removeItem('searchFilter');
		dispatch({
			type: 'drawerOpen',
			payload: !globalState.drawerOpen,
		});
	};

	//subscription //subscription //subscription

	// const {
	// 	loading: getPrintDataLoading,
	// 	data: { getPrintData } = { getPrintData: {} as any },
	// } = useGetPrintDataSubscription({
	// 	variables: {
	// 		outletID: printOutletID,
	// 	},
	// 	client: WSclient,
	// });

		const [
		loadkitchenPrinter,
		{
			loading: getKitchenPrinterLoading,
			data: { getKitchenPrinter } = { getKitchenPrinter: [] },
		},
	] = useGetKitchenPrinterLazyQuery({
		fetchPolicy: 'network-only',
	});

	const [
		loadPrinterOrderItem,
		{
			loading: getPrinterOrderItemLoading,
			data: { getPrinterOrderItem } = { getPrinterOrderItem: [] },
		},
	] = useGetPrinterOrderItemLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: () => {
			generateReceiptData();
		},
	});
	const [
		loadOrder,
		{ loading: orderLoading, data: { getOrder } = { getOrder: [] } },
	] = useGetOrderLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: () => {
			setPrintOnce(true);
		},
	});

	const {
		loading: getOutletCustomerPolicyLoading,
		data: { getOutletCustomerPolicy } = { getOutletCustomerPolicy: [] },
	} = useGetOutletCustomerPolicyQuery({
		skip: !printOutletID,
		fetchPolicy: 'network-only',
		variables: {
			outletID: printOutletID as string,
		},
	});

	const isConfirmOrSummary =
		location.pathname.includes('confirm-order') ||
		location.pathname.includes('order-summary') ||
		location.pathname.includes('grid');
	console.log(location.pathname, isConfirmOrSummary, 'getOutletCustomerPolicy');
	const [
		loadReceiptPrinter,
		{
			loading: receiptPrinterLoading,
			called: receiptPrinterCalled,
			data: { getReceiptPrinter } = { getReceiptPrinter: [] },
		},
	] = useGetReceiptPrinterLazyQuery({
		fetchPolicy: 'network-only',
	});

	const path = location?.pathname;
	const isNotAuthPage = !['/login', '/logout', '/kitchen'].includes(path);

	const [socketPrintDataList, setSocketPrintDataList] = useState<any[]>([]);
	useEffect(() => {
		if (socket) {
			socket.on('socketPrint', socketPrint => {
				console.log(socketPrint, 'socketPrint');
				try {
					if (socketPrint?.type === 'POST_PRINT_DATA') {
						if (
							isNotAuthPage &&
							socketPrint?.printData?.printerName &&
							socketPrint?.printData?.userID === user?.ID
						) {
							// Push (append) new print data at the end
							setSocketPrintDataList(prev => [
								...(Array.isArray(prev) ? prev : []),
								socketPrint?.printData,
							]);

							loadReceiptPrinter({
								variables: {
									isDefault: true,
									outletID: printOutletID,
								},
							});

							loadkitchenPrinter({
									variables: {
										outletID: printOutletID,
									},
								});
								
							loadPrinterOrderItem({
								variables: {
									orderID: socketPrint?.printData?.orderID,
									orderItemIDs: socketPrint?.printData?.orderItemIDs,
								},
							});
							loadOrder({
								variables: {
									ID: socketPrint?.printData?.orderID,
									status: OrderStatus.Open,
									outletID: printOutletID,
								},
							});
						}
					}
				} catch (err) {
					console.error('Error handling disconnect:', err);
				}
			});

			// Add error handling
			socket.on('error', error => {
				console.error('Socket error:', error);
			});
		}
	}, [socket]);

	// useEffect(() => {
	// 	if (
	// 		(location?.pathname !== '/login' ??
	// 			location?.pathname !== '/logout' ??
	// 			location?.pathname !== '/kitchen') &&
	// 		getPrintData?.printerName &&
	// 		getPrintData?.userID === user?.ID
	// 	) {
	// 		loadReceiptPrinter({
	// 			variables: {
	// 				isDefault: true,
	// 				outletID: printOutletID,
	// 			},
	// 		});
	// 		loadPrinterOrderItem({
	// 			variables: {
	// 				orderID: getPrintData?.orderID,
	// 				orderItemIDs: getPrintData?.orderItemIDs,
	// 			},
	// 		});
	// 		loadOrder({
	// 			variables: {
	// 				ID: getPrintData?.orderID,
	// 				status: OrderStatus.Open,
	// 				outletID: printOutletID,
	// 			},
	// 		});
	// 	}
	// }, [getPrintData]);

	const [uniqueKpArray, setUniqueKpArray] = useState([]);
	const [uniqueKpInfoArray, setUniqueKpInfoArray] = useState([]);
	const [kpObj, setKpObject] = useState({});
	const [printerName, setPrinterName] = useState(null);
	const [kitchenPrinterObj, setKitchenPrinterObj] = useState([]);
	const [shouldQueryRun, setShouldQueryRun] = useState(false); // Track whether to run the query

	useEffect(() => {
		if (getPrinterOrderItem?.length > 0) {
			generateReceiptData();
		}
	}, [getPrinterOrderItem]);

	const generateReceiptData = () => {
		// Step 1: Create a Set of unique printer names, using fallback 'NonKitchenPrinter'
		let kp1ID = new Set(
			getPrinterOrderItem
				?.map(oi => oi?.menuItem?.kitchenPrinterID)
				.filter(id => id != null), // filters out null and undefined
		);

		let kp2ID = new Set(
			getPrinterOrderItem
				?.map(oi => oi?.menuItem?.kitchenPrinter2ID)
				.filter(id => id != null),
		);

		let kpPlusID = new Set([...kp1ID, ...kp2ID]);
		let uniqueprinterName = new Set(
						getKitchenPrinter
				?.filter(kp => kpPlusID.has(kp?.ID))
				?.map(kp => kp?.name),
		);
		let uniqueprinterInfo = new Set(
			getPrinterOrderItem?.map(oi => oi?.menuItem?.kitchenPrinter),
		);
		setUniqueKpArray([...uniqueprinterName]);
		setUniqueKpInfoArray([...uniqueprinterInfo]);

		// Step 2: Organize order items into an object keyed by printer name
		let temporaryObject: Record<string, any[]> = {};

		getPrinterOrderItem?.forEach(oi => {
			// Use fallback if kitchenPrinter or name is missing
			// const printerName = oi?.menuItem?.kitchenPrinter?.name;

			const kp1ID = oi?.menuItem?.kitchenPrinterID;
			const kp2ID = oi?.menuItem?.kitchenPrinter2ID;

			// Get printer names safely
			const printerName1 = getKitchenPrinter?.find(kp => kp?.ID === kp1ID)
				?.name;
			const printerName2 = getKitchenPrinter?.find(kp => kp?.ID === kp2ID)
				?.name;
			// Initialize array if not already
			// 
			if (printerName1) {
				if (!temporaryObject[printerName1]) temporaryObject[printerName1] = [];
				temporaryObject[printerName1].push(oi);
			}
			if (printerName2) {
				if (!temporaryObject[printerName2]) temporaryObject[printerName2] = [];
				temporaryObject[printerName2].push(oi);
			}
		});

		setKpObject(temporaryObject);
	};

	// Define the routes where you DON'T want to run the query
	const blockedRoutes = ['/login'];

	useEffect(() => {
		if (login && !blockedRoutes.includes(location.pathname)) {
			setShouldQueryRun(true);
		}
	}, [location.pathname]);
	const {
		loading: userLoading,
		error,
		data: { getUsersByAccountAndSoftware } = {
			getUsersByAccountAndSoftware: [],
		},
	} = useGetUsersByAccountAndSoftwareQuery({
		fetchPolicy: 'network-only',
		variables: {
			status: CommonStatus.Active,
		},
		skip: !shouldQueryRun,
	});

	console.log(socketPrintDataList, uniqueKpArray, 'socketPrint');

	let obj;
	const handlePrinting = async () => {
		if (uniqueKpArray?.length > 0) {
			let objArray: any = [];
			await uniqueKpArray?.map(async (printerName, index) => {
				const obj =
					kpObj[printerName] ?? kpObj[printerName || 'NonKitchenPrinter'] ?? [];
				objArray.push(...(Array.isArray(obj) ? obj : []));
				setKitchenPrinterObj(obj);
				setPrinterName(printerName || 'NonKitchenPrinter');
				const payload = socketPrintDataList[0];
				const printData =
					payload?.printerConfigs?.find(
						(p: any) => p?.printerName === printerName,
					) ?? payload;
				const findPrinterInfo = uniqueKpInfoArray?.find(
					(info: any) => info?.name === printerName,
				);
				const isSDK = printData?.isSDK ?? payload?.isSDK;
				const connectType = printData?.connectType ?? payload?.connectType;
				const deviceIP = findPrinterInfo?.deviceIP ?? findPrinterInfo?.address;
				const deviceAlignment =
					printData?.deviceAlignmentCode ?? payload?.printerdeviceAlignmentCode;
				console.log('socket connectType', connectType);

				if (isSDK === true) {
					await printReceiptText(
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						printerName,
						'server',
						null,
						'order-receipt',
						null,
						payload?.outletName,
						getOrder[0],
						getOrder[0]?.table,
						obj,
						payload?.orderMode,
						null,
						payload?.voidQuantity,
						payload?.reasonCode,
						payload?.remark,
						null,
						null,
						null,
						null,
						null,
						getUsersByAccountAndSoftware,
						null,
						null,
						null,
					);
				} else if (isSDK === false && connectType === 'NETWORK') {
					try {
						await printOrderReceiptRawViaLocalAgent({
							outletName: payload?.outletName,
							orderData: getOrder[0],
							tableData: getOrder[0]?.table,
							orderItemData: obj,
							orderMode: payload?.orderMode,
							voidQuantity: payload?.voidQuantity,
							reasonCode: payload?.reasonCode,
							remark: payload?.remark,
							printerName: deviceIP,
							receiptType: 'order-receipt',
							width: deviceAlignment,
						});
					} catch (e) {
						console.warn(
							'Local Print Agent (order-receipt):',
							(e as Error)?.message ?? e,
						);
					}
				}
			});
			console.log(objArray, uniqueKpArray, 'kitchen1');
			if (getOutletCustomerPolicy[0]?.tableOrderPrint === true) {
				console?.log('hereprinter');
				if (socketPrintDataList[0]?.isSDK === true) {
					await printReceiptText(
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						getReceiptPrinter[0]?.name,
						'server',
						null,
						'guest-order-receipt',
						null,
						socketPrintDataList[0]?.outletName,
						getOrder[0],
						getOrder[0]?.table,
						objArray,
						socketPrintDataList[0]?.orderMode,
						null,
						socketPrintDataList[0]?.voidQuantity,
						socketPrintDataList[0]?.reasonCode,
						socketPrintDataList[0]?.remark,
						null,
						null,
						null,
						null,
						null,
						getUsersByAccountAndSoftware,
						null,
						null,
						null,
					);
				} else if (
					socketPrintDataList[0]?.isSDK === false &&
					socketPrintDataList[0]?.connectType === 'NETWORK'
				) {
					try {
						await printOrderReceiptRawViaLocalAgent({
							outletName: socketPrintDataList[0]?.outletName,
							orderData: getOrder[0],
							tableData: getOrder[0]?.table,
							orderItemData: objArray,
							orderMode: socketPrintDataList[0]?.orderMode,
							voidQuantity: socketPrintDataList[0]?.voidQuantity,
							reasonCode: socketPrintDataList[0]?.reasonCode,
							remark: socketPrintDataList[0]?.remark,
							printerName: getReceiptPrinter[0]?.deviceIP, // TODO: remove hardcode after testing
							receiptType: 'guest-order-receipt',
							width: getReceiptPrinter[0]?.deviceAlignmentCode,
						});
					} catch (e) {
						console.warn(
							'Local Print Agent (guest-order-receipt):',
							(e as Error)?.message ?? e,
						);
					}
				}
			}
		}
		setPrintOnce(false);
		setSocketPrintDataList(null);
		return true;
	};

	// console?.log(getPrintData, uniqueKpArray, '00');

	useEffect(() => {
		if (
			uniqueKpArray?.length > 0 &&
			printOnce === true
			// && getOrder?.length > 0
		) {
			// printReceipt(getPrintData.dataURL, getPrintData.printerName, 'server');
			if (isConfirmOrSummary === true) {
				handlePrinting();
			}
		}

		return () => {
			// Unsubscribe from the subscription
			client.stop();
		};
	}, [
		// uniqueKpArray,
		printOnce,
	]);
	const handleSnackbarClose = () => {
		setsnackbarClosed(true);
		setOpen(false);
	};

	return (
		<>
			{
				!getPrinterOrderItemLoading
				// && !orderLoading
			}
			<Snackbar
				className=""
				style={{ top: '10px', right: '10px' }}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={open}
				autoHideDuration={3000}
				onClose={() => setOpen(true)}
				ContentProps={{
					'aria-describedby': 'message-id',
					style: { backgroundColor: 'white', color: 'red' },
				}}
				message={<span id="message-id">Listening to print requests...</span>}
				action={
					// Show IconButton with Close icon if notification is START
					<IconButton
						key="close"
						aria-label="close"
						color="inherit"
						onClick={handleSnackbarClose}
					>
						<CloseIcon />
					</IconButton>
				}
			/>
		</>
	);
};
